import { css } from "@emotion/css";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { ReactNode } from "react";
import React from "react";
import type { ConfiguredSource, ConfiguredSources } from "~/areas/infrastructure/components/ArgoCDInstances/components/GenerateArgoCDAnnotationsDrawer/ConfiguredSource";
import { SourceCard } from "~/areas/infrastructure/components/ArgoCDInstances/components/GenerateArgoCDAnnotationsDrawer/components/SourceCard";
const styles = {
    sourceCardsContainer: css({
        display: "flex",
        flexDirection: "column",
        gap: space[16],
    }),
    sourceCounter: css({
        font: text.body.regular.xSmall,
        color: themeTokens.color.text.secondary,
        margin: 0,
        marginBottom: space[8],
    }),
};
type SourceCardListProps = {
    configuredSources: ConfiguredSources;
    isMultiSourceApplication: boolean;
    cardContentRenderer: (key: string, configuredSource: ConfiguredSource) => ReactNode;
    showMissingNameWarning?: boolean;
    hideSourceHeader?: boolean;
};
export const SourceCardList = (props: SourceCardListProps) => {
    const { configuredSources, isMultiSourceApplication, cardContentRenderer, showMissingNameWarning, hideSourceHeader } = props;
    const configuredSourcesEntries = Object.entries(configuredSources);
    const hideSourceCounter = configuredSourcesEntries.length === 1;
    return (<div className={styles.sourceCardsContainer}>
            {configuredSourcesEntries.map(([key, configuredSource], index) => {
            const src = configuredSource.source;
            return (<div key={key}>
                        {isMultiSourceApplication && !hideSourceCounter && (<p className={styles.sourceCounter}>
                                Source {index + 1} of {configuredSourcesEntries.length}
                            </p>)}
                        <SourceCard source={src} isMultiSourceApplication={isMultiSourceApplication} showMissingNameWarning={showMissingNameWarning || false} hideHeader={hideSourceHeader || false}>
                            {cardContentRenderer(key, configuredSource)}
                        </SourceCard>
                    </div>);
        })}
        </div>);
};
